import type { SVGProps } from "react";

export default function LaughReactionIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 8C1 3.575 4.575 0 9 0C13.425 0 17 3.575 17 8C17 12.425 13.425 16 9 16C4.575 16 1 12.425 1 8ZM11.25 6C11.25 5.57614 11.5761 5.25 12 5.25C12.4239 5.25 12.75 5.57614 12.75 6C12.75 6.27614 12.9739 6.5 13.25 6.5C13.5261 6.5 13.75 6.27614 13.75 6C13.75 5.02386 12.9761 4.25 12 4.25C11.0239 4.25 10.25 5.02386 10.25 6C10.25 6.27614 10.4739 6.5 10.75 6.5C11.0261 6.5 11.25 6.27614 11.25 6ZM5.82501 5.25C5.40115 5.25 5.07501 5.57614 5.07501 6C5.07501 6.27614 4.85115 6.5 4.57501 6.5C4.29887 6.5 4.07501 6.27614 4.07501 6C4.07501 5.02386 4.84887 4.25 5.82501 4.25C6.80115 4.25 7.57501 5.02386 7.57501 6C7.57501 6.27614 7.35115 6.5 7.07501 6.5C6.79887 6.5 6.57501 6.27614 6.57501 6C6.57501 5.57614 6.24887 5.25 5.82501 5.25ZM12.1727 8.5C12.406 8.5 12.6393 8.60468 12.809 8.7931C12.9574 8.96059 13.0423 9.21182 12.9786 9.46305C12.2999 11.431 10.9849 12.75 8.99128 12.75C6.99761 12.75 5.51294 11.431 5.00394 9.46305C4.98273 9.21182 5.04635 8.98153 5.21603 8.7931C5.3857 8.60468 5.5978 8.5 5.85231 8.5H12.1727Z"
        fill="currentColor"
      />
    </svg>
  );
}
